export default __webpack_public_path__ + "static/setup_jag_scan-18bc38f790f9e382c8e985a76760893b.png";